import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ComingSoon } from "./motion";
import { money } from "../../lib/products";

export const ProductCard = ({ product }) => (
  <Link to={`/shop/${product.slug}`} data-testid={`product-card-${product.slug}`} className="group block">
    <div className="spotlight-frame relative aspect-[4/5] overflow-hidden rounded-[28px] bg-dano-sand">
      <img src={product.image} alt={product.name} className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.06]" />
      <div className="absolute left-4 top-4">{product.comingSoon && <ComingSoon />}</div>
      <span className="absolute bottom-4 right-4 grid h-12 w-12 place-items-center rounded-full bg-dano-cream text-dano-ink transition-transform duration-500 group-hover:rotate-45 group-hover:bg-dano-red group-hover:text-dano-cream">
        <ArrowUpRight className="h-5 w-5" />
      </span>
    </div>
    <div className="mt-5 flex items-start justify-between gap-4">
      <div>
        <p className="font-cond text-sm uppercase tracking-[0.2em] text-dano-red">{product.number}</p>
        <h3 className="mt-1 font-wide text-xl sm:text-2xl uppercase">{product.name}</h3>
        <p className="mt-1 text-sm text-dano-ink/75">{product.size} · {product.protein} protein</p>
      </div>
      <p className="font-cond text-lg whitespace-nowrap text-right" data-testid={`product-card-price-${product.slug}`}>
        {product.variants?.length ? `from ${money(product.variants[0].price)}` : "Price coming soon"}
      </p>
    </div>
  </Link>
);
